import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiTool, FiInfo } from 'react-icons/fi';

const GenericPage = ({ title }) => {
  return (
    <div className="h-[calc(100vh-8rem)] flex flex-col items-center justify-center text-center p-6">
      <div className="w-20 h-20 bg-blue-50 rounded-2xl flex items-center justify-center mb-6 shadow-sm border border-blue-100">
        <SafeIcon icon={FiTool} className="text-4xl text-blue-500" />
      </div>
      <h1 className="text-3xl font-bold text-slate-800 mb-3">{title}</h1>
      <p className="text-slate-500 max-w-md mb-8">
        This section is currently part of the frontend shell. 
        Data structures and UI components for <span className="font-semibold text-slate-700">{title}</span> will be implemented in the next phase.
      </p>
      
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex items-start gap-3 max-w-md text-left">
        <SafeIcon icon={FiInfo} className="text-amber-600 text-lg shrink-0 mt-0.5" />
        <div>
          <h4 className="text-sm font-semibold text-amber-800 mb-1">Mock Environment</h4>
          <p className="text-xs text-amber-700 leading-relaxed">
            No real data is stored or exposed here. All API keys and provider secrets are simulated for UI development purposes only.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GenericPage;